'use strict';
var dialog = require('./dialog'),
	address = require('./pages/checkout/address'),
	shipping = require('./pages/checkout/shipping');
	var $cache = {};

function initializeCache() {
    $cache.primary = $('#primary');
    var expressCheckout = $cache.primary.find('.submit-express-order').length > 0;
    if (expressCheckout) {
    	$cache.checkoutForm = $cache.primary.find('.submit-express-order');
        $cache.submitFormButton =$cache.checkoutForm.find('button.spc-summary-btn');
    } else {
    	$cache.checkoutForm = $cache.primary.find('.checkout-shipping.address').length > 0 ? $cache.primary.find('.checkout-shipping.address') : $cache.primary.find('.checkout-billing.address');
    	$cache.submitFormButton = $cache.checkoutForm.find('button.saveShipping').length > 0 ? $cache.checkoutForm.find('button.saveShipping') : $cache.checkoutForm.find('button[name$=_save]');
    }
    $cache.validatoionDialog = $cache.primary.find('#address-validation-dialog');
    $cache.suggestedAddress = $cache.primary.find('#ship-to-address-selected')
    $cache.byPassDAV = $cache.checkoutForm.find('.bypassDAV');
    $cache.address1 = $cache.checkoutForm.find('input[name$="_address1"]');
    $cache.address2 = $cache.checkoutForm.find('input[name$="_address2"]');
    $cache.city = $cache.checkoutForm.find('input[name$="_city"]');
    $cache.stateCode = $cache.checkoutForm.find('select[id$="_state"]');
    $cache.countryCode = $cache.checkoutForm.find('select[id$="_country"]');
    $cache.postalCode = $cache.checkoutForm.find('input[name$="_postal"]');
    $cache.avsValidated = $cache.checkoutForm.find('.avsValidated');
}

function initializeDom() {
    if ($cache.validatoionDialog.length > 0) {

        var dlg = dialog.create({
            target: $cache.validatoionDialog,
            options: {
                width: 594,
				height: 'auto',
                dialogClass: 'address-validation-dialog',
                open: initializeEvents
            }
        });

        $cache.validatoionDialog.show();
        $(".address-validation-dialog").find('#address-validation-dialog').removeClass("hide");
        $(".address-validation-dialog").find('#address-validation-dialog').css({height:'auto'});

        dlg.dialog('open');
        
    }
}

function scrollToActiveTab(){
	if(!$(".ui-dialog").is(":visible")) {
		var xpressCheckout = $(".checkout-tabs").hasClass("spc-express-checkout");
		var $checkoutHeaderHeight = $('.header-mian-banner').outerHeight();
		if(xpressCheckout) {
			$(window).load(function(){
				if(!$(".ui-dialog").is(":visible")) {
					if($('.checkout-tab-head.open').length) {
				    	$('html, body').animate({ scrollTop: $('.checkout-tab-head.open').offset().top - $('.pt_checkout #header').outerHeight() - 12 }, 700);
				    }
				}
			});
		} else {
			if($(window).width() < 768) {
				$checkoutHeaderHeight = $('.fixed-header').outerHeight();
			}
		    if($('.checkout-tab-head.open').length)
		        $('html, body').animate({ scrollTop: $('.checkout-tab-head.open').offset().top - $checkoutHeaderHeight - 15 }, 700);
		}
	}
}


function initializeEvents() {
	/* PXSFCC-4495_WCAG_Modal_focus_management */
	$(".ui-dialog").find(".ui-dialog-titlebar-close").on("mouseenter",function(){
    	$(this).focus();
    });
    $(".ui-dialog").find(".ui-dialog-titlebar-close").trigger("mouseenter");
    
    $cache.validatoionDialog.on('click', '#cancel-avs-button,.update-avs-button', function () {
    	var $useAsBillingField = $('input[name$="_useAsBillingAddress"]');
    	var $useAsBillingFieldVal = $useAsBillingField.prop('checked');
        $cache.validatoionDialog.dialog('close');
        $('.edit-section .shipping-add-edit').trigger('click');
        address.init();
        if($useAsBillingFieldVal) {
        	$useAsBillingField.prop('checked', true);
        	$useAsBillingField.val("true");
        } else {
        	$useAsBillingField.prop('checked', false);
        	$useAsBillingField.val("false");
        }
        shipping.retainShippingMethodList(null, $('[name$="_shippingMethodID"]:checked'));
        scrollToActiveTab();
    });
    
    $cache.validatoionDialog.on('click', '#selected-address-continue', function () {
    	var checkedField = $("input[name='avs-address']:checked");
    	if($(checkedField).val() == "original address val"){
    		$cache.validatoionDialog.dialog('close');
	        $cache.byPassDAV.attr('value', 'true');
	        $cache.avsValidated.attr('value', 'false');
	        $cache.submitFormButton.click();
    	} else {
    		var selectedAddress = $cache.suggestedAddress.data('address').split('||');
			$cache.address1.val(selectedAddress[0]);
			$cache.address2.val('');
    	    if (selectedAddress[1] !== 'undefined' && selectedAddress[1] !== '') {
    	    	  $cache.address2.val(selectedAddress[1]); 
            }
			$cache.city.val(selectedAddress[2]);
			$cache.stateCode.val(selectedAddress[3]);
			$cache.countryCode.val(selectedAddress[4]);
			$cache.postalCode.val(selectedAddress[5]);
			$cache.byPassDAV.attr('value', 'true');
			$cache.validatoionDialog.dialog('close');
			$cache.avsValidated.attr('value', 'true');
			$cache.submitFormButton.click();
    	}
    });
    $cache.validatoionDialog.on('click', '.corrected-avs-button', function () {
    	$cache.validatoionDialog.dialog('close');
        $cache.byPassDAV.attr('value', 'true');
        $cache.avsValidated.attr('value', 'false');
    	$cache.submitFormButton.click();
    	shipping.retainShippingMethodList(2, $('[name$="_shippingMethodID"]:checked'));
    	scrollToActiveTab();
    });
    shipping.init();
}

exports.init = function() {
    initializeCache();
    initializeDom();
};
